import React from 'react';

import OrderCard from './OrderCard';
import OrderCardExpandable from './OrderCardExpandable';
import Sorting from './other/Sorting';
import Pagination from './other/Pagination';

function OrdersList({
  orders,
  sortBy,
  sortDir,
  sortOptions,
  onSortChange,
  filterBy,
  filterOptions,
  onFilterChange,
  showSorting,
  hasNextPage,
  loadingMore,
  onLoadMore,
}) {
  return (
    <div id="orders">
      {showSorting && (
        <Sorting
          sortBy={sortBy}
          sortDir={sortDir}
          sortOptions={sortOptions}
          onSortChange={onSortChange}
          filterBy={filterBy}
          filterOptions={filterOptions}
          onFilterChange={onFilterChange}
        />
      )}

      <div id="orders-container">
        {orders.map((order, index) => (
          <OrderCardExpandable key={order.id} order={order} index={index} filterBy={filterBy}/>
        ))}
      </div>

      <Pagination hasNextPage={hasNextPage} loadingMore={loadingMore} onLoadMore={onLoadMore} />
    </div>
  );
}

export default OrdersList;
